module.exports = __webpack_public_path__ + "static/media/ic_camera.b033b433.svg";